import authInstance from "../utilities/axios/authInstance";

export const allCheckpoints = () => authInstance.get('checkpoints');

export const oneCheckpoint = (id) => authInstance.get('checkpoints/' + id);

export const addCheckpoint = (checkpoint) => authInstance.post('checkpoints', checkpoint);

export const updateCheckpoint = (id, checkpoint) => authInstance.put('checkpoints/' + id, checkpoint);

export const removeCheckpoint = (id) => authInstance.delete('checkpoints/' + id);